import * as ko from 'knockout'
import {myTripsApi, TripDto} from '../../api/api-wrapper'
import globalState from "../../global-state";
import {isSharedTrip} from "../share/shareUtils";
import {Context} from "@profiscience/knockout-contrib-router";
import {computed} from "knockout-decorators";

class ViewModel {

    /**
     * The trips.
     */
    public trips: KnockoutObservableArray<TripDto>;

    /**
     * Flag if it's the users first visit.
     * On mobile the introduction should be visible only to new visitors.
     * see DRC-593.
     */
    public firstVisit: boolean;

    /**
     * The cookie name for a previous DRC visit.
     * @private
     */
    private cookieName = "drcVisited";

    constructor(ctx: Context) {
        this.trips = globalState.trips;
        this.firstVisit = localStorage.getItem(this.cookieName) !== 'true' &&
            !document.cookie.split(';').some(item => item.trim().startsWith(this.cookieName));
        localStorage.setItem(this.cookieName, 'true');
    }

    /**
     * Introduction is hidden on mobile
     * - if the cookie for a previous visit is set
     * - or if the user has already trips created (auto login on new device)
     */
    @computed
    public get hideIntroduction() {
        return this.trips.length > 0 || !this.firstVisit;
    }

    /**
     * Get the trip destinations as a comma separated string.
     * @param trip
     */
    destinations(trip: TripDto): KnockoutComputed<string> {
        return ko.pureComputed(() =>
            trip.destinations.map(destination => destination.name).join(", ")
        );
    }

    public tripPictureUrl(trip: TripDto): string {
        return trip.imageUrl ? 'url(' + config.imagePath + '/' + trip.imageUrl  + ') ' :
            `url(${config.defaultImage})`;
    }

    public isSharedTrip(trip: TripDto) {
        return isSharedTrip(trip);
    }
}

export default <KnockoutLazyPageDefinition>{
    viewModel: ViewModel,
    template: require('./home.html'),
    componentName: "home",
    loader: (ctx) => {
        // reloads trips into global-state
        if ((<any>ctx).isLogout) {
            globalState.trips([]);
        } else if (globalState.isLoggedIn()) {
            myTripsApi.getChecklistTrips().then(trips => globalState.trips(trips.data || []));
        }
        return Promise.resolve();
    }
};
